module.exports = __webpack_public_path__ + "img/certificate5.ce6a014e.png";